import React from "react";
import { CheckCircle2, Trees, Dumbbell, Stethoscope } from "lucide-react";
import { Card } from "@/components/ui/card";
import { RadioCard, SectionLabel } from "./FormPrimitives";

export const ExtraFlagsCard = ({ form, setField }) => (
  <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
    <Card className="border-zinc-200 shadow-sm">
      <div className="p-6">
        <SectionLabel hint={form.code_mode === "manual" ? "Optional" : "Required"}>Wooden Goods</SectionLabel>
        <p className="text-sm text-zinc-700 mb-3">Is this wooden?</p>
        <div className="grid grid-cols-2 gap-3">
          <RadioCard testid="radio-wooden-yes" checked={form.is_wooden === true} onClick={() => setField("is_wooden", true)} icon={Trees} label="Yes" sublabel="Adds W" />
          <RadioCard testid="radio-wooden-no" checked={form.is_wooden === false} onClick={() => setField("is_wooden", false)} icon={CheckCircle2} label="No" sublabel="Skip" />
        </div>
      </div>
    </Card>
    <Card className="border-zinc-200 shadow-sm">
      <div className="p-6">
        <SectionLabel hint={form.code_mode === "manual" ? "Optional" : "Required"}>Protein Supplement</SectionLabel>
        <p className="text-sm text-zinc-700 mb-3">Is this a protein supplement?</p>
        <div className="grid grid-cols-2 gap-3">
          <RadioCard testid="radio-protein-yes" checked={form.is_protein_supplement === true} onClick={() => setField("is_protein_supplement", true)} icon={Dumbbell} label="Yes" sublabel="Adds BB" />
          <RadioCard testid="radio-protein-no" checked={form.is_protein_supplement === false} onClick={() => setField("is_protein_supplement", false)} icon={CheckCircle2} label="No" sublabel="Skip" />
        </div>
      </div>
    </Card>
    <Card className="border-zinc-200 shadow-sm">
      <div className="p-6">
        <SectionLabel hint={form.code_mode === "manual" ? "Optional" : "Required"}>Medical Items</SectionLabel>
        <p className="text-sm text-zinc-700 mb-3">Is this medical related?</p>
        <div className="grid grid-cols-2 gap-3">
          <RadioCard testid="radio-medical-yes" checked={form.is_medical === true} onClick={() => setField("is_medical", true)} icon={Stethoscope} label="Yes" sublabel="Adds M" />
          <RadioCard testid="radio-medical-no" checked={form.is_medical === false} onClick={() => setField("is_medical", false)} icon={CheckCircle2} label="No" sublabel="Skip" />
        </div>
      </div>
    </Card>
  </div>
);
